import TestPackageSampleModel from "@/models/lab/TestPackageSampleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TestPackageSampleCollection extends LabServiceCollection {
  model() {
    return TestPackageSampleModel;
  }

  prepareFilter(filter) {
    filter.sortAddAsc("name");

    return filter;
  }
}
